/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const IncidentRecordSummaryDto = zod.object({
  "id": zod.string().uuid().optional(),
  "incidentNumber": zod.string().optional(),
  "incidentTypeId": zod.number().optional(),
  "incidentTypeName": zod.string().optional(),
  "statusId": zod.number().optional(),
  "statusName": zod.string().optional(),
  "dateReported": zod.coerce.date().optional(),
  "cycleAge": zod.number().optional(),
  "reportedMemberId": zod.string().uuid().optional(),
  "reportedMemberName": zod.string().optional(),
  "reporterMemberId": zod.string().uuid().optional(),
  "reporterMemberName": zod.string().optional(),
  "createdDate": zod.coerce.date().optional(),
  "createdByName": zod.string().optional()
});

export type IncidentRecordSummaryDto = zod.input<typeof IncidentRecordSummaryDto>;
export type IncidentRecordSummaryDtoOutput = zod.output<typeof IncidentRecordSummaryDto>;
